const jmdRcu = function (robotType, blockSeparator, categorySeparator, isStage, targetId) {
    switch (robotType) {
        case 'E6':
            return `
                <category name="%{BKY_CATEGORY_JMDE6RCU}" id="jmd" colour="#00afae" secondaryColour="#0b9c9b" showLabelButton="true">
                <block id="${targetId}" type="jmd_start"/>
                ${blockSeparator}
                <block type="jmd_getLeftButton"/>
                <block type="jmd_getRightButton"/>
                ${blockSeparator}
                <block type="jmd_setControlTimeZero"/>
                <block type="jmd_getControlTime"/>
                ${blockSeparator}
                <block type="jmd_setInSound">
                    <value name="TIME">
                        <shadow type="jmd_time_menu">
                        </shadow>
                    </value>
                </block>
                <block type="jmd_setBeep"/>
                <block type="jmd_getInMic"/>
                ${blockSeparator}
                <block type="jmd_setData">
                    <value name="ADDRESS">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="jmd_getData">
                    <value name="ADDRESS">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="jmd_setUartData">
                    <value name="DATA">
                        <shadow type="math_number">
                            <field name="NUM">255</field>
                        </shadow>
                    </value>
                </block>
                <block type="jmd_getUartData"/>
                ${blockSeparator}
                <block type="jmd_getBatteryVoltage"/>
                ${categorySeparator}
                </category>
                `;
        case 'C1':
            return `
                <category name="%{BKY_CATEGORY_JMDE6RCU}" id="jmd" colour="#00afae" secondaryColour="#0b9c9b" showLabelButton="true">
                <block id="${targetId}" type="jmd_start_C1"/>
                ${blockSeparator}
                <block type="jmd_getLeftButton"/>
                <block type="jmd_getRightButton"/>
                <block type="jmd_releaseButton"/>
                <block type="jmd_setControlTimeZero"/>
                <block type="jmd_getControlTime"/>
                <block type="jmd_getInMic"/>
                <block type="jmd_setBeep"/>
                <block type="jmd_getData">
                    <value name="ADDRESS">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="jmd_setData">
                    <value name="ADDRESS">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="jmd_setRGB">
                        <value name="COLOR1">
                            <shadow type="colour_picker_Red">
                                
                            </shadow>
                        </value>
                        <value name="COLOR2">
                            <shadow type="colour_picker_Orange">
                                
                            </shadow>
                        </value>
                        <value name="COLOR3">
                            <shadow type="colour_picker_Yellow">
                                
                            </shadow>
                        </value>
                        <value name="COLOR4">
                            <shadow type="colour_picker_Green">
                                
                            </shadow>
                        </value>
                        <value name="COLOR5">
                            <shadow type="colour_picker_Blue">
                                
                            </shadow>
                        </value>
                    </block>
                    <block type="jmd_setInSound">
                        <value name="TIME">
                            <shadow type="jmd_time_menu">
                            </shadow>
                        </value>
                    </block>
                    <block type="jmd_setMusic"/>
                    <block type="jmd_set3CLed"/>
                    
                ${categorySeparator}
                </category>
                `;
        case 'A2':
            return `
                <category 
                    name="%{BKY_CATEGORY_JMDE6RCU}"
                    id="jmd"
                    colour="#00afae"
                    secondaryColour="#0b9c9b"
                >
                    <block id="${targetId}" type="jmd_start_A2"/>
                    ${blockSeparator}
                    <block type="jmd_setMotorPin">
                        <value name="SPEED">
                            <shadow type="jmd_speed">
                            </shadow>
                        </value>
                    </block>
                    <block type="jmd_poinMode"/>
                    <block type="jmd_digitalwrite"/>
                    <block type="jmd_anglogRead"/>
                    <block type="jmd_digitalRead"/>
                    <block type="jmd_getCodePin"/>
                </category>
                `;
        case 'E3':
            return `
                <category name="%{BKY_CATEGORY_JMDE6RCU}" id="jmd" colour="#00afae" secondaryColour="#0b9c9b" showLabelButton="true">
                <block id="${targetId}" type="jmd_start"/>
                <block type="jmd_getLeftButton"/>
                <block type="jmd_getRightButton"/>
                <block type="jmd_setControlTimeZero"/>
                <block type="jmd_getControlTime"/>
                <block type="jmd_getInMic"/>
                <block type="jmd_setBeep"/>
                <block type="jmd_getBatteryVoltage"/>
                <block type="jmd_getData">
                    <value name="ADDRESS">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="jmd_setData">
                    <value name="ADDRESS">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="jmd_set3CLed"/>
                <block type="jmd_setUartData">
                    <value name="DATA">
                        <shadow type="math_number">
                            <field name="NUM">255</field>
                        </shadow>
                    </value>
                </block>
                <block type="jmd_getUartData"/>
                    
                ${categorySeparator}
                </category>
                `;
        case 'M6':
            return `
                <category name="%{BKY_CATEGORY_JMDE6RCU}" id="jmd" colour="#00afae" secondaryColour="#0b9c9b" showLabelButton="true">
                <block id="${targetId}" type="jmd_start"/>
                ${blockSeparator}
                <block type="jmd_getLeftButton"/>
                <block type="jmd_getRightButton"/>
                ${blockSeparator}
                <block type="jmd_setControlTimeZero"/>
                <block type="jmd_getControlTime"/>
                ${blockSeparator}
                <block type="jmd_setInSound">
                    <value name="TIME">
                        <shadow type="jmd_time_menu">
                        </shadow>
                    </value>
                </block>
                <block type="jmd_setBeep"/>
                <block type="jmd_getInMic"/>
                ${blockSeparator}
                <block type="jmd_setData">
                    <value name="ADDRESS">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="jmd_getData">
                    <value name="ADDRESS">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="jmd_setUartData">
                    <value name="DATA">
                        <shadow type="math_number">
                            <field name="NUM">255</field>
                        </shadow>
                    </value>
                </block>
                <block type="jmd_getUartData"/>
                ${categorySeparator}
                <block type="jmd_getBatteryVoltage"/>
                </category>
                `;
        case 'C6':
            return `
                <category name="%{BKY_CATEGORY_JMDE6RCU}" id="jmd" colour="#00afae" secondaryColour="#0b9c9b" showLabelButton="true">
                <block id="${targetId}" type="jmd_start"/>
                ${blockSeparator}
                <block type="jmd_getLeftButton"/>
                <block type="jmd_getRightButton"/>
                ${blockSeparator}
                <block type="jmd_setControlTimeZero"/>
                <block type="jmd_getControlTime"/>
                ${blockSeparator}
                <block type="jmd_setInSound">
                    <value name="TIME">
                        <shadow type="jmd_time_menu">
                        </shadow>
                    </value>
                </block>
                <block type="jmd_setBeep"/>
                <block type="jmd_getInMic"/>
                ${blockSeparator}
                <block type="jmd_setData">
                    <value name="ADDRESS">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="jmd_getData">
                    <value name="ADDRESS">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="jmd_setUartData">
                    <value name="DATA">
                        <shadow type="math_number">
                            <field name="NUM">255</field>
                        </shadow>
                    </value>
                </block>
                <block type="jmd_getUartData"/>
                ${categorySeparator}
                <block type="jmd_getBatteryVoltage"/>
                </category>
                `;
        case 'E7':
            return `
                <category name="%{BKY_CATEGORY_JMDE6RCU}" id="jmd" colour="#00afae" secondaryColour="#0b9c9b" showLabelButton="true">
                <block id="${targetId}" type="jmd_start"/>
                <block type="E7_jmd_setData">
                    <value name="ADDRESS">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                    <value name="VALUE">
                        <shadow type="math_number">
                            <field name="NUM">10</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_jmd_getData">
                    <value name="ADDRESS">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_GetHRCUName"/>
                <block type="jmd_getChangeValue"/>
                <block type="jmd_getMaiVoice"/>
                <block type="jmd_getRcuTime"/>
                <block type="E7_jmd_savePic">
                    <value name="NAME">
                        <shadow type="textvalue">
                            <field name="TEXT">FileName</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_jmd_setSaveStudyDataToFile">
                    <value name="DATA">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                    <value name="NAME">
                        <shadow type="text">
                            <field name="TEXT">data</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_jmd_setDeleteStudyFile">
                    <value name="NAME">
                        <shadow type="text">
                            <field name="TEXT">data</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_jmd_setShowFileData">
                    <value name="NAME">
                        <shadow type="text">
                            <field name="TEXT">data</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_setEditView">
                    <value name="LEFTMARGIN">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                    <value name="RIGHTMARGIN">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                    <value name="MESSAGE">
                        <shadow type="textvalue">
                            <field name="TEXT">请输入数值</field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_getEditViewData"/>

                <block type="jmd_setRcuTimeTo0"/>
                <block type="E7_GetCcrrentDate"/>
                <block type="E7_SetSaveStrToFile">
                    <value name="STRING">
                        <shadow type="textvalue">
                            <field name="TEXT"></field>
                        </shadow>
                    </value>
                    <value name="FILENAME">
                        <shadow type="textvalue">
                            <field name="TEXT"></field>
                        </shadow>
                    </value>
                </block>
                <block type="E7_GetStrForFile">
                    <value name="FILENAME">
                        <shadow type="textvalue">
                            <field name="TEXT"></field>
                        </shadow>
                    </value>
                    <value name="LINENUM">
                        <shadow type="math_number">
                            <field name="NUM"></field>
                        </shadow>
                    </value>
                </block>
                ${categorySeparator}
                </category>
                `;

        case 'STORM_OS':
            return `
                <category name="%{BKY_CATEGORY_JMDE6RCU}" id="jmd" colour="#00afae" secondaryColour="#0b9c9b" showLabelButton="true">
                <block type="STORM_OS_jmd_start"/>
                
                <block type="STORM_OS_record_audio">
                    <value name="SECOND">
                        <shadow type="math_number">
                            <field name="NUM">5</field>
                        </shadow>
                    </value>
                    <value name="FILENAME">
                        <shadow type="textvalue">
                            <field name="TEXT">output.wav</field>
                        </shadow>
                    </value>
                </block>
                <block type="STORM_OS_play_preset_audio"></block>
                <block type="STORM_OS_play_audio">
                    <value name="FILENAME">
                        <shadow type="textvalue">
                            <field name="TEXT">output.wav</field>
                        </shadow>
                    </value>
                </block>
                <block type="STORM_OS_tone">
                    <value name="VOLUME">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                    <value name="SECOND">
                        <shadow type="math_number">
                            <field name="NUM">2</field>
                        </shadow>
                    </value>
                </block>
                <block type="STORM_OS_beep"></block>
                <block type="STORM_OS_fan_speed"></block>
                <block type="STORM_OS_set_fan_speed">
                    <value name="SPEED">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                </block>
                <block type="STORM_OS_fw_version"></block>
                <block type="STORM_OS_battery"></block>
                <block type="STORM_OS_charging"></block> 
                <block type="STORM_OS_reset"></block> 
                ${categorySeparator}
                </category>
                `;
        case 'M5':
            return `
                <category name="%{BKY_CATEGORY_JMDE6RCU}" id="jmd" colour="#00afae" secondaryColour="#0b9c9b">
                <block id="${targetId}" type="jmd_start"/>
                <block type="jmd_setBeep"/>
                <block type="jmd_M5_GetSysButton"/>
                ${categorySeparator}
                </category>
                `;
        default:
            return `<category 
                    name="%{BKY_CATEGORY_JMDE6RCU}"
                    id="jmd" 
                    colour="#00afae"
                    secondaryColour="#0b9c9b"
                    showLabelButton="true">
                </category>
            `;
    }
};

export default jmdRcu
;
